module.exports = __webpack_public_path__ + "img/Música.31611205.svg";